import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  onGetAttachmentTypes,
  onGetConfirmationStatuses,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
import {
  onCreateAttachment,
  onDeleteAttachment,
  onGetAttachment,
  onGetPagedAllAttachments,
  onUpdateAttachment,
} from '../../../app/modules/areas/graduates/attachments/core/_requests'
interface AttachmentState {
  allAttachments: any
  attachment: any
  attachmentTypes: any
  isLoading: boolean
}
const initialState = {
  allAttachments: [],
  attachment: null,
  attachmentTypes: [],
  isLoading: true,
} as AttachmentState

export const fetchAttachmentTypes = createAsyncThunk(
  'attachment/fetchAttachmentTypes',
  async () => {
    const data: any = await onGetAttachmentTypes()
    return data.data.result.items
  }
)

export const fetchAllAttachments = createAsyncThunk(
  'attachment/fetchAllAttachments',
  async (param: any) => {
    const data: any = await onGetPagedAllAttachments(param)
    return data.data.result
  }
)

export const fetchAttachment = createAsyncThunk(
  'attachment/fetchAttachment',
  async (param: any) => {
    const data: any = await onGetAttachment(param)
    return data.data.result
  }
)

export const updateAttachment = createAsyncThunk(
  'attachment/updateAttachment',
  async (param: any) => {
    const data: any = await onUpdateAttachment(param)
    return data.data
  }
)

export const createAttachment = createAsyncThunk(
  'attachment/createAttachment',
  async (param: any) => {
    const data: any = await onCreateAttachment(param)
    return data.data
  }
)

export const deleteAttachment = createAsyncThunk(
  'attachment/deleteAttachment',
  async (param: any) => {
    const data: any = await onDeleteAttachment(param)
    return data.data
  }
)

const attachmentSlice = createSlice({
  name: 'attachment',
  initialState,
  reducers: {
    clearAllAttachments: (state) => {
      state.allAttachments = []
    },
    clearAttachment: (state) => {
      state.attachment = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllAttachments.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchAllAttachments.fulfilled, (state: any, action) => {
      state.allAttachments = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchAllAttachments.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchAttachment.fulfilled, (state: any, action) => {
      state.attachment = action.payload
    })
    builder.addCase(fetchAttachmentTypes.fulfilled, (state: any, action) => {
      state.attachmentTypes = action.payload
    })
  },
})

export const {clearAllAttachments, clearAttachment, activateLoading} = attachmentSlice.actions

export default attachmentSlice.reducer
